import { Button, Link, Stack, Typography } from '@mui/material';

import LockIcon from '@/components/Icons/LockIcon';
import useIsTrainingEnabled from '@/hooks/useIsTrainingEnabled';
import { links } from '@/localization';

import { TrainingAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';

function EmptyState() {
  const isTrainingEnabled = useIsTrainingEnabled();
  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={500} gap={4}>
        <TrainingAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t created any training jobs yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Run reproducible, scalable training jobs with full control over data, code, compute, and
            runtime settings.{' '}
            <Link href={links.basetenDocsTrainingOverview} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        {isTrainingEnabled ? (
          <Button href={links.basetenDocsTrainingOverview} target="_blank">
            Start a Training job
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            href="https://www.baseten.co/talk-to-us/request-access/"
            target="_blank"
            endIcon={<LockIcon />}
          >
            Request access
          </Button>
        )}
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
